import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/integration-framework/page.tsx");
